import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 110 110',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2" transform="translate(0 0.002)">
        <path
          fill={fill}
          d="M64,105.891,99.129,131.51a10.15,10.15,0,0,0,12.045,0L146.3,105.891V70.924A6.892,6.892,0,0,0,139.445,64H70.859A6.892,6.892,0,0,0,64,70.924ZM84.576,84.772a3.446,3.446,0,0,1,3.429-3.462H122.3a3.446,3.446,0,0,1,3.429,3.462v3.462A3.446,3.446,0,0,1,122.3,91.7H88.005a3.446,3.446,0,0,1-3.429-3.462Zm0,17.31a3.446,3.446,0,0,1,3.429-3.462H122.3a3.446,3.446,0,0,1,3.429,3.462v3.462a3.446,3.446,0,0,1-3.429,3.462H88.005a3.446,3.446,0,0,1-3.429-3.462Z"
          transform="translate(-50.152 -50.154)"
          opacity="0.5"
        />
        <path
          fill={fill}
          d="M75.625,34.373a3.437,3.437,0,0,0-3.438-3.437H37.813a3.437,3.437,0,0,0-3.437,3.437v3.437a3.437,3.437,0,0,0,3.438,3.437H72.188a3.437,3.437,0,0,0,3.438-3.437Zm-3.438,13.75H37.813a3.437,3.437,0,0,0-3.437,3.437V55a3.437,3.437,0,0,0,3.438,3.437H72.188A3.438,3.438,0,0,0,75.625,55V51.56A3.438,3.438,0,0,0,72.188,48.123ZM70.77,8.893C67.16,6.272,59.984-.066,55,0,50.016-.066,42.84,6.272,39.23,8.893l-6.574,4.855H77.344ZM13.75,27.713c-5.135,3.8-9.174,6.789-9.8,7.3A10.312,10.312,0,0,0,0,43.117v2.3l13.75,9.926Zm92.3,7.3c-.623-.494-4.662-3.5-9.8-7.283V55.342L110,45.416v-2.3a10.312,10.312,0,0,0-3.953-8.1ZM55,89.609a17.185,17.185,0,0,1-10.074-3.264L0,53.9V99.685A10.312,10.312,0,0,0,10.313,110H99.688A10.312,10.312,0,0,0,110,99.685V53.9L65.076,86.344A17.187,17.187,0,0,1,55,89.609Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
